import React, { useState } from 'react';
import { ReactComponent as Close } from '../../../assets/images/teamclose.svg';
import Input from '../../common/InputField';
import { useDispatch, useSelector } from 'react-redux';
import { createTicket } from '../../../store/features/createTicket';
import { toast } from 'react-toastify';
import { useSocket } from '../../../SocketContext';

function ChatTicketPopup(props) {
  const dispatch = useDispatch();
  const socket = useSocket();
  const userData = useSelector((state) => state.loginToken);
  const [email, setEmail] = useState('');
  const [assignedName, setAssignName] = useState('');
  const [ticket, setTicket] = useState('');
  const { setTicketPopup, selectUser } = props;
  const { businessId, id, customerId } = selectUser;
  const [loading, setLoading] = useState(false);

  console.log("Selected User in ChatTicketPopup :", selectUser);
  const validateForm = () => {
    if (!email.trim() || !assignedName.trim() || !ticket.trim()) {
      toast.error("All fields are required.");
      return false;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }

    if (!isNaN(ticket.trim())) {
      toast.error("Ticket subject should not be only numeric.");
      return false;
    }

    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    const ticketData = {
      subject: ticket,
      chatRoom: id,
      business_id: businessId,
      customerEmail: email,
      customerName: assignedName,
      customerId: customerId,
      custom_widget: selectUser?.is_guest ? true : false,
    };

    dispatch(createTicket(ticketData))
      .then((response) => {
        toast.success("Ticket created successfully!");

        if (socket && response?.payload?.data) {
          socket.emit('create-ticket', {
            ticketId: response.payload.data._id,
            agentId: userData?.response?.user?._id,
            businessId: userData?.response?.user?.business_id,
            ticket: response.payload.data
          });
        }

        setLoading(false);
        setTicketPopup(false);
      })
      .catch(() => {
        toast.error("Failed to create ticket.");
        setLoading(false);
      });
  };

  return (
    <>
      <div className="overlay" style={{zIndex: 50}} />
      <div className="Team-PopUp-Container">
        <div className="Team-PopUp-Header">
          <p className="PopUp-Text01">Create a ticket</p>
          <p className="PopUp-Text02" onClick={() => setTicketPopup(false)}>
            <Close />
          </p>
        </div>

        <form className="PopUp-Email-Container" onSubmit={handleSubmit}>

          <Input
            type="text"
            value={assignedName}
            onChange={(e) => setAssignName(e.target.value)}
            title="Customer’s Name"
            placeholder="Enter customer name"
          />
          <br />
          <Input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            title="Customer’s email"
            placeholder="Enter email address"
          />
          <br />
          <Input
            type="text"
            title="Ticket subject"
            onChange={(e) => setTicket(e.target.value)}
            value={ticket}
            placeholder="Enter ticket subject"
          />
          <div className="Ticket-Button-Container">
            <button
              className="buttonstyle-Cancel"
              type="button"
              onClick={() => setTicketPopup(false)}
            >
              Cancel
            </button>
            <button
              className="buttonstyle-Ticket"
              type="submit"
              disabled={loading}
            >
              {loading ? "Creating..." : "Create Ticket"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default ChatTicketPopup;